/** Release 1 owner carve-out, frozen to main 764808c5cd until the release 2 review. */
export function isSettingsDeferredOwnerPath(href: string): boolean {
  const path = href.split(/[?#]/, 1)[0] ?? '';
  return /^(?:\/settings\/(?:payroll|leave-policies|cert-allowance-registry|integrations\/xero)|\/payroll|\/leave|\/me\/leave|\/roster\/timesheets|\/api\/xero)(?:\/|$)/.test(
    path,
  );
}

/** Shared Settings pages may contain an owner-held control without deferring the page. */
export function isSettingsDeferredOwnerSource(path: string): boolean {
  return (
    /^(?:apps\/web\/src\/(?:lib\/(?:payroll|leave|integrations\/xero)\/|components\/(?:payroll|xero)\/|app\/\(dashboard\)\/(?:payroll\/|leave\/|me\/leave\/|roster\/timesheets\/|settings\/(?:payroll|leave-policies|cert-allowance-registry|integrations\/xero)\/)|app\/api\/(?:xero\/|cron\/(?:roster-optimiser|[^/]*(?:pay-context|leave|xero)[^/]*)\/))|packages\/(?:payroll-connectors\/|utils\/src\/(?:award-engines|payroll|award-data)\/))/.test(
      path,
    ) ||
    path === 'apps/web/src/lib/settings/auto-timesheet-actions.ts' ||
    // HR whistleblower obligations arrived from main after the release 1 review;
    // they keep main's behaviour until the HR owner's delegation review.
    path === 'apps/web/src/components/hr/WhistleblowerObligations.tsx' ||
    path === 'apps/web/src/lib/hr/whistleblower-obligation-actions.ts' ||
    path === 'apps/web/src/app/(dashboard)/settings/notification-routing/AutoTimesheetCard.tsx'
  );
}

/** DOC-48 release 1: declared NOI sources retain main until DTSS closes.
 * Page access still follows Settings; these command bodies and presentations are frozen. */
export const SETTINGS_NOI_DEFERRED_DISPOSITION =
  "deferred to release 2 — NOI source frozen until DTSS closes 12 Oct 2026; main's own action authority retained; Settings narrowing not applied";

export const SETTINGS_NOI_FROZEN_SOURCES = [
  'apps/web/src/app/(dashboard)/clients/[id]/government-record-actions.ts',
  'apps/web/src/app/(dashboard)/settings/integrations/services-australia/actions.ts',
  'apps/web/src/app/(dashboard)/settings/integrations/services-australia/aged-care-rest-config-form.tsx',
  'apps/web/src/app/(dashboard)/settings/integrations/services-australia/conformance/page.tsx',
  'apps/web/src/app/(dashboard)/settings/integrations/services-australia/event-reconciliation/page.tsx',
  'apps/web/src/app/(dashboard)/settings/integrations/services-australia/mapping/actions.ts',
  'apps/web/src/app/(dashboard)/settings/integrations/services-australia/mapping/provider-service-mapping-wizard.tsx',
  'apps/web/src/app/(dashboard)/settings/integrations/services-australia/noi-mutation-settings-actions.ts',
  'apps/web/src/app/(dashboard)/settings/integrations/services-australia/noi-mutation-settings.tsx',
  'apps/web/src/app/(dashboard)/settings/integrations/services-australia/page.tsx',
  'apps/web/src/app/(dashboard)/settings/integrations/services-australia/proda-lifecycle-settings-actions.ts',
  'apps/web/src/app/(dashboard)/settings/integrations/services-australia/proda-lifecycle-settings.tsx',
  'apps/web/src/app/(dashboard)/settings/integrations/services-australia/proda-noi-receipt-actions.ts',
  'apps/web/src/app/(dashboard)/settings/integrations/services-australia/proda-noi-receipt-panel.tsx',
  'apps/web/src/components/integrations/ServicesAustraliaConformanceHarness.tsx',
  'apps/web/src/components/integrations/government-operation-result.tsx',
] as const;

export function isSettingsNoiDeferredSource(path: string): boolean {
  return (SETTINGS_NOI_FROZEN_SOURCES as readonly string[]).includes(path);
}
